import { pluginApi } from 'services/api';
import { ReportIncome } from './interfaces';

export default async (): Promise<ReportIncome[]> => {
  const { data } = await pluginApi.get('/participants/report-income/');

  return data;
};
